export enum UserCalendarUrl {
  CALENDAR = '/user-dashboard/calendar',
  CURRENT_NEXT_LOAD_CALC = '/user-dashboard/current-next-load-calc',
  LAST_TRANSFER_SUBJECTS = '/user-dashboard/last-transfer-subjects',
  INPUT_COLLECTION = '/user-dashboard/input-collection',
  WAITING_STATUSES = '/user-dashboard/waiting-statuses',
  LATEST_COMMENTS = '/user-dashboard/latest-comments',
  USER_READ_COMMENT = '/user-dashboard/user-read-comment',
  LAST_CALCULATIONS = '/user-dashboard/last-calculations',
  SUSPENDED_LOADINGS = '/user-dashboard/suspended-loadings',
}
